module.exports = __webpack_public_path__ + "static/media/profile.bd993129.jpg";